"use client";

import { FormEvent, useState } from "react";

const FORMSPREE_ENDPOINT =
  process.env.NEXT_PUBLIC_FORMSPREE_TEAM_FORM ||
  "https://formspree.io/f/your-form-id";

export function TeamInterestForm() {
  const [status, setStatus] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsSubmitting(true);
    setStatus(null);

    const form = event.currentTarget;
    const formData = new FormData(form);

    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (res.ok) {
        setStatus("✓ Thanks! We'll review your request and be in touch soon.");
        form.reset();
      } else {
        const data = await res.json();
        console.error("Submission error:", res.status, data);
        setStatus(
          "Error submitting form. Please try again or email us directly.",
        );
      }
    } catch (error) {
      console.error("Network error:", error);
      setStatus(
        "Unable to submit. Please email us directly at contact@noreasterrugby.org",
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <input
        name="school"
        required
        placeholder="School"
        className="w-full rounded-md border border-storm/30 px-3 py-2"
      />
      <input
        name="contact_name"
        required
        placeholder="Contact name"
        className="w-full rounded-md border border-storm/30 px-3 py-2"
      />
      <input
        name="email"
        type="email"
        required
        placeholder="Email"
        className="w-full rounded-md border border-storm/30 px-3 py-2"
      />
      <input
        name="phone"
        placeholder="Phone"
        className="w-full rounded-md border border-storm/30 px-3 py-2"
      />
      <textarea
        name="notes"
        placeholder="Notes"
        className="w-full rounded-md border border-storm/30 px-3 py-2"
        rows={3}
      />
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full rounded-md bg-navy px-4 py-2 font-semibold text-white disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitting ? "Sending..." : "Submit interest"}
      </button>
      {status && (
        <p
          className={`text-sm ${status.startsWith("✓") ? "text-green-600" : "text-red-600"}`}
        >
          {status}
        </p>
      )}
    </form>
  );
}
